export function truncatePackingDescription(description: string | undefined) {
  if (description && description.length > 10) {
    return `${description.substring(0, 10)}...`;
  }
  return description || '';
}

export function truncateProductDescription(
  description: string | null | undefined
) {
  if (description && description.length > 25) {
    return `${description.substring(0, 25)}...`;
  }
  return description || '';
}

export function truncateCreatedBy(createdBy: string | null | undefined) {
  if (createdBy && createdBy.length > 20) {
    return `${createdBy.substring(0, 20)}...`;
  }
  return createdBy;
}

export function truncateCustomerName(customerName: string | null | undefined) {
  if (customerName && customerName.length > 25) {
    return `${customerName.substring(0, 25)}...`;
  }
  return customerName || '';
}

export function truncateObservation(observation: string | null | undefined) {
  if (observation && observation.length > 30) {
    return `${observation.substring(0, 30)}...`;
  }
  return observation || '';
}

export function truncateRequester(requester: string | null | undefined) {
  if (requester && requester.length > 70) {
    return `${requester.substring(0, 70)}...`;
  }
  return requester || '';
}
